import axios from 'Services/axiosInterceptor';
import * as action_types from './constants';
import { externalBaseUrl } from '../../../../configs/constants';

export const getAds = (page, limit, order, orderby, search = {}, load) => {
  load && load(true);
  let ordering = '';
  if (order == "ascend") {
    ordering = 'ASC'
  } else if (order == "descend") {
    ordering = 'DESC'
  }
  return async (dispatch) => {
    const {
      data: { data, meta },
    } = await axios.post(`${externalBaseUrl}/ads/list`, {
      q: JSON.stringify({
        title_cont: search?.title,
        s: `${orderby} ${ordering}`
      }),
      page: page,
      limit: limit
    });
    load && load(false);
    dispatch({
      type: action_types.ADS_LIST,
      data: data,
      meta: meta
    });
  };
};

export const getAd = (id, load) => {
  load && load(true);
  return async (dispatch) => {
    const {
      data: { data, meta },
    } = await axios.post(`${externalBaseUrl}/ads/get`, {
      ad_id: id
    });
    load && load(false);
    dispatch({
      type: action_types.ADS_DETAIL,
      data: data,
      meta: meta
    });
  };
};

export const getAdProducts = (page, limit, order, orderby, load, id) => {
  load && load(true);
  let ordering = '';
  if (order == "ascend") {
    ordering = 'ASC'
  } else if (order == "descend") {
    ordering = 'DESC'
  }
  return async (dispatch) => {
    const {
      data: { data, meta },
    } = await axios.post(`${externalBaseUrl}/ads/ad-product-list`, {
      q: JSON.stringify({
        s: `${orderby} ${ordering}`
      }),
      ad_id: id,
      page: page,
      limit: limit
    });
    load && load(false);
    dispatch({
      type: action_types.ADS_PRODUCT_LIST,
      data: data,
      meta: meta
    });
  };
};

export const getAdProduct = (id, load) => {
  load && load(true);
  return async (dispatch) => {
    const {
      data: { data, meta },
    } = await axios.post(`${externalBaseUrl}/ads/ad-product-get`, {
      ad_product_id: id
    });
    load && load(false);
    dispatch({
      type: action_types.ADS_PRODUCT_DETAIL,
      data: data,
      meta: meta
    });
  };
};

export const getRewards = (page, limit, order, orderby, load) => {
  load && load(true);
  let ordering = '';
  if (order == "ascend") {
    ordering = 'ASC'
  } else if (order == "descend") {
    ordering = 'DESC'
  }
  return async (dispatch) => {
    const {
      data: { data, meta },
    } = await axios.post(`${externalBaseUrl}/rewards/list`, {
      q: JSON.stringify({
        s: `${orderby} ${ordering}`
      }),
      page: page,
      limit: limit
    });
    load && load(false);
    dispatch({
      type: action_types.REWARDS_LIST,
      data: data,
      meta: meta
    });
  };
};

export const getReward = (id, load) => {
  load && load(true);
  return async (dispatch) => {
    const {
      data: { data, meta },
    } = await axios.post(`${externalBaseUrl}/rewards/get`, {
      reward_id: id
    });
    load && load(false);
    dispatch({
      type: action_types.REWARDS_DETAIL,
      data: data,
      meta: meta
    });
  };
};